import React from "react";
import type { SessionReportResponse, StudentReportData } from "../../../interfaces/sessionReport";
import { useLocalization } from "../../../stores/localizationContext";
import "./SessionReportTable.scss";

interface SessionReportTableProps {
  data: SessionReportResponse;
}

const SessionReportTable: React.FC<SessionReportTableProps> = ({ data }) => {
  const { t } = useLocalization();

  const firstStudent = data.session_report[0];
  const columns: StudentReportData[] = firstStudent
    ? [...firstStudent.student_data].sort((a, b) => a.display_order - b.display_order)
    : [];

  return (
    <div className="session-report-table">
      <div className="session-report-table__header-row">
        <span className="session-report-table__cell session-report-table__cell--name">
          {t("student_name_label", "Student Name")}
        </span>
        {columns.map((col) => (
          <span
            key={col.localization_key}
            className="session-report-table__cell"
          >
            {t(col.localization_key, col.localization_key)}
          </span>
        ))}
      </div>

      {data.session_report.map((student, index) => {
        const sortedData = [...student.student_data].sort(
          (a, b) => a.display_order - b.display_order
        );

        return (
          <div
            key={index}
            className={`session-report-table__row${index % 2 !== 0 ? " session-report-table__row--striped" : ""}`}
          >
            <span className="session-report-table__cell session-report-table__cell--name" dir="auto">
              {student.student_name}
            </span>
            {sortedData.map((item) => (
              <span key={item.localization_key} className="session-report-table__cell">
                {item.value}%
              </span>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SessionReportTable;
